import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'horizontal',
      isDefault: true
    },
    'vertical'
  ],
  modifiers: [
    {
      title: 'default',
      isDefault: true
    },
    'primary',
    'inverse'
  ],
  states: []
}
export default function Divider(props) {
  const { dataDivider, inverse, vertical, primary, ...rest } = props
  return <hr {...rest} className={resolveProps(props, config, 'Divider')} />
}

Divider.propTypes = {
  inverse: PropTypes.bool,
  primary: PropTypes.bool,
  vertical: PropTypes.bool,
  dataDivider: PropTypes.array
}
